<template>
    <div>
        <h1>{{ $t('pages.reset-initiate.title') }}</h1>
        <div class="form-group" v-if="waiting>0">
            <p>
                {{ $t('pages.reset-initiate.please_wait', {waiting: waiting}) }}
            </p>
        </div>
        <div class="form-group" v-if="waiting===0">
            <p>{{ $t('pages.reset-initiate.where_is_my_token')}}</p>
            <label class="col-form-label" for="username">
                {{ $t('pages.reset-initiate.placeholder_username') }}
            </label>
            <div class="input-group mb-3">
                <input type="text" class="form-control"
                       :placeholder="$t('pages.reset-initiate.placeholder_username')"
                       name="username" id="username" v-model="username" ref="username">
                <div class="input-group-append">
                    <div class="input-group-text">
                        <span class="fas fa-user-alt"></span>
                    </div>
                </div>
            </div>
            <div class="input-group mb-3">
                <input type="text" class="form-control"
                       :placeholder="$t('pages.reset-initiate.placeholder_token')"
                       name="token" id="token" v-model="token" ref="token">
                <div class="input-group-append">
                    <div class="input-group-text">
                        <span class="fas fa-key"></span>
                    </div>
                </div>
            </div>
            <b-button block type="submit" variant="primary" :disabled="!isSendable" v-on:click="initiateReset">
                <b-icon-arrow-right/>
                {{ $t('pages.reset-initiate.button_submit') }}
            </b-button>
            <b-button size="sm" block href="/forgot">
                {{ $t('pages.reset-initiate.again') }}
            </b-button>
        </div>


    </div>

</template>

<script>
import LoadingInjector from "../../mixins/LoadingInjector";

export default {
    mixins: [
        LoadingInjector
    ],
    props: {
        regexAccount: {
            required: true,
            type: String,
        }
    },

    data() {
        return {
            username: '',
            token: '',
            waiting: 0
        }
    },
    created() {
        this.errorHandler = this.$shared.errorHandlerForResponder;
    },
    mounted() {
        console.log('Mounted initiate-reset.');
    },
    methods: {
        initiateReset: function () {
            this.axios.post(this.$Bologna.secure_url(`/v1/reset-initiate/${this.username}`), {
                value: this.token,
            })
                .then(response => {
                    if (response.data.data.wait_time_sec) {
                        this.waiting = response.data.data.wait_time_sec;
                    }
                    //window.location = '/reset';
                })
                .catch(error => {
                    this.token = '';
                });
        }
    },
    computed: {
        isSendable: function () {
            console.log('isSendable()');
            let regex = new RegExp(`^${this.regexAccount}$`);
            return regex.test(this.username) && this.token.length > 3;
        },
    },
    watch: {
        isSendable: function (val) {
            return val === true;
        },
        waiting: function (val) {
            if (val > -1) {
                setTimeout(() => {
                    this.waiting--;
                }, 1000);
            }

            if (val === -1) {
                window.location = '/reset';
            }
        }
    }
};
</script>
